export const modes = [
  {
    key: 'blur',
    handler: () => {
      return {
        on: ['blur', 'on-blur']
      };
    }
  },

  {
    key: 'input',
    handler: () => {
      return {
        on: ['input', 'on-change']
      };
    }
  },

  {
    key: 'eager',
    handler: ({ errors }) => {
      if (errors.length) {
        return {
          on: ['input', 'on-change']
        };
      }

      return {
        on: ['blur', 'on-blur', 'on-change']
      };
    }
  },

  {
    key: 'passive_aggressive',
    handler: ({ errors }) => {
      if (errors.length) {
        return {
          on: ['input', 'on-change']
        };
      }

      return {
        on: []
      };
    }
  }
];
